module.exports = __webpack_public_path__ + "img/8.39d40b6.jpg";